module.exports = "https://beta.voredev.ru/assets/index/vk-mini-bdde25bfd9bad0880bd88ec0aeef1e57.svg";